export default __webpack_public_path__ + "AUt_addUser.html";